import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Axios from "axios";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";

import cellBackground from "../../assets/images/home/big-cell.png";

import "./styles.scss";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const formSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(2, "¡Muy corto!")
    .max(50, "¡Muy largo!")
    .required("Campo obligatorio"),
  dni: Yup.number("¡Solo numeros!")
    .min(10000, "¡Muy corto!")
    .max(100000000, "¡Muy largo!")
    .required("Campo obligatorio"),
  matricula: Yup.number("¡Solo numeros!")
    .min(1, "¡Muy corto!")
    .max(1000000, "¡Muy largo!")
    .required("Campo obligatorio"),
  telefono: Yup.string()
    .matches(phoneRegExp, "Teléfono inválido")
    .required("Campo obligatorio"),
	email: Yup.string().email("Email inválido"),
  comentario: Yup.string().min(2, "¡Muy corto!")
});

class Quiz extends React.Component {
  render() {
    return (
      <main className="main quiz">
        <section className="hero">
          <div className="hero__wrapper container">
            <h1 className="hero__title">¿Sabías qué...?</h1>
            <p className="hero__description">
              Conocé más sobre nosotros y{" "}
              <strong>¡participá por un viaje a Iguazú!</strong>
            </p>
          </div>
        </section>
        <Formik
          initialValues={{
            nombre: "",
            dni: "",
            matricula: "",
            email: "",
            telefono: "",
            comentario: "",
            calidadYExcelencia: false,
            calidadYEquipamiento: false,
            equipamiento: false,
            instalaciones: false,
            capacidadDeAnalisis: false
          }}
          validationSchema={formSchema}
          onSubmit={(values, actions) => {
            console.log('submit', values, actions);
            actions.setStatus({
              success: "Enviando…",
              css: "sending"
            });
            actions.setSubmitting(false);

            Axios.post("https://formcarry.com/s/0dKQeyDcyO3", {
              nombre: values.nombre,
              dni: values.dni,
              matricula: values.matricula,
              email: values.email,
              telefono: values.telefono,
              comentario: values.comentario,
              calidadYExcelencia: values.calidadYExcelencia,
              calidadYEquipamiento: values.calidadYEquipamiento,
              equipamiento: values.equipamiento,
              instalaciones: values.instalaciones,
              capacidadDeAnalisis: values.capacidadDeAnalisis
            })
              .then(function(response) {
                if (response.status === 200) {
                  actions.setStatus({
                    success: "¡Enviado!",
                    css: "success"
                  });
                  actions.setSubmitting(true);
                } else {
                  actions.setStatus({
                    success: "Algo salió mal. Volvé a intentar",
                    css: "error"
                  });
                  actions.setSubmitting(false);
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }}
          render={({ errors, status, touched, isSubmitting }) => (
            <Form>
              {console.log(errors, status, touched, isSubmitting)}
              <section className="section questions container">
                <div className="questions__wrapper">
                  <section id="calidad-y-excelencia" className="question">
                    <div className="section__wrapper">
                      <h2 className="subtitle">
                        Calidad y Excelencia <i>(1/5)</i>
                      </h2>
                      <h3 className="title">
                        Desde 1982, laboratorio acreditado por la Fundación
                        Bioquímica Argentina.
                      </h3>
                      <p className="text">
                        Participamos del programa de{" "}
                        <strong>Control de la Calidad Externa</strong>, mediante
                        el procesamiento de muestras incógnitas en forma mensual
                        para mantener este status de calidad. La Fundación
                        Bioquímica establece como mínimo la participación en los
                        Programas de Quimica Clinica, Hematologia y Orinas, pero
                        nosotros también participamos desde hace 10 años en los
                        Siguientes Subprogramas que nos{" "}
                        <strong>aseguran la calidad</strong> en cada unos de
                        ellos:
                      </p>
                      <ul className="unordered-list">
                        <li className="unordered-list__item">
                          Marcadores Tumorales.
                        </li>
                        <li className="unordered-list__item">
                          Endocrinología.
                        </li>
                        <li className="unordered-list__item">Bacteriología.</li>
                        <li className="unordered-list__item">Parasitología.</li>
                        <li className="unordered-list__item">
                          Control de equipamiento.
                        </li>
                        <li className="unordered-list__item">Proteinograma.</li>
                        <li className="unordered-list__item">
                          Electroforético.
                        </li>
                        <li className="unordered-list__item">Hemostasia.</li>
                      </ul>
                    </div>
                    <div className="question__input">
                      <p className="question__input__text">¿Lo sabías?</p>
                      <div className="question__input__input">
                        <Field
                          type="checkbox"
                          name="calidadYExcelencia"
                          id="calidadYExcelencia"
                        />
                        <label htmlFor="calidadYExcelencia"></label>
                      </div>
                    </div>
                  </section>
                  <section id="calidad-y-equipamiento" className="question">
                    <div className="section__wrapper">
                      <h2 className="subtitle">
                        Calidad y Equipamiento <i>(2/5)</i>
                      </h2>
                      <h3 className="title">
                        Participamos del Control de Calidad Internacional
                        propuesto por CEMIC.
                      </h3>
                      <p className="text">
                        Desde la adquisición del equipo para la realización de{" "}
                        <strong>determinaciones de Quimioluminiscencia</strong>{" "}
                        de última generación Snibe Maglumi 800 en el año 2018,
                        participamos en el{" "}
                        <strong>Programa de Hormonas Tiroideas</strong> de dicha
                        institución.
                      </p>
                    </div>
                    <div className="question__input">
                      <p className="question__input__text">¿Lo sabías?</p>
                      <div className="question__input__input">
                        <Field
                          type="checkbox"
                          name="calidadYEquipamiento"
                          id="calidadYEquipamiento"
                        />
                        <label htmlFor="calidadYEquipamiento"></label>
                      </div>
                    </div>
                  </section>
                  <section id="equipamiento" className="question">
                    <div className="section__wrapper">
                      <h2 className="subtitle">
                        Equipamiento <i>(3/5)</i>
                      </h2>
                      <h3 className="title">
                        Equipamiento con menos de
                        <br /> 5 años de antigüedad.
                      </h3>
                      <p className="text">
                        Teniendo así una flota de{" "}
                        <strong>equipos de última generación</strong> con lo que
                        esto conlleva a la hora de la calidad del resultado y a
                        la{" "}
                        <strong>
                          capacidad de proceso de Determinaciones modernas
                        </strong>{" "}
                        que van tomando protagonismo en el uso diario de la
                        medicina.
                      </p>
                    </div>
                    <div className="question__input">
                      <p className="question__input__text">¿Lo sabías?</p>
                      <div className="question__input__input">
                        <Field
                          type="checkbox"
                          name="equipamiento"
                          id="equipamiento"
                        />
                        <label htmlFor="equipamiento"></label>
                      </div>
                    </div>
                  </section>
                  <section id="instalaciones" className="question">
                    <div className="section__wrapper">
                      <h2 className="subtitle">
                        Instalaciones <i>(4/5)</i>
                      </h2>
                      <h3 className="title">
                        Brindamos un excelente y seguro servicio a nuestros
                        pacientes.
                      </h3>
                      <p className="text">
                        Nuestras nuevas instalaciones en la dirección{" "}
                        <strong>
                          Pueyrredón 367 de la Ciudad de Las Flores
                        </strong>{" "}
                        cumple con los{" "}
                        <strong>más altos requerimientos y exigencias</strong>,
                        como son entre otras el acceso por rampa, la libre
                        movilidad de sillas de ruedas, baños aptos para
                        discapacitados, sensores de humo, salida de emergencia,
                        entre otras.
                      </p>
                    </div>
                    <div className="question__input">
                      <p className="question__input__text">¿Lo sabías?</p>
                      <div className="question__input__input">
                        <Field
                          type="checkbox"
                          name="instalaciones"
                          id="instalaciones"
                        />
                        <label htmlFor="instalaciones"></label>
                      </div>
                    </div>
                  </section>
                  <section id="capacidad-de-analisis" className="question">
                    <div className="section__wrapper">
                      <h2 className="subtitle">
                        Capacidad de análisis <i>(5/5)</i>
                      </h2>
                      <h3 className="title">
                        Capacidad y velocidad en el procesamiento de estudios.
                      </h3>
                      <p className="text">
                        Podemos procesar el{" "}
                        <strong>
                          90% de las determinaciones de análisis que hoy se
                          encuentran en el mercado
                        </strong>
                        , desde las más antiguas a las más modernas, y aquellas
                        que no efectuamos sólo se debe a la baja frecuencia de
                        solicitud de las mismas. A su vez, procesamos más del 80
                        % de las determinaciones el{" "}
                        <strong>mismo dia de la extracción</strong>, por lo cual
                        usted y el paciente recibe a las horas los resultados
                        del mismo.
                      </p>
                    </div>
                    <div className="question__input">
                      <p className="question__input__text">¿Lo sabías?</p>
                      <div className="question__input__input">
                        <Field
                          type="checkbox"
                          name="capacidadDeAnalisis"
                          id="capacidadDeAnalisis"
                        />
                        <label htmlFor="capacidadDeAnalisis"></label>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="questions__nav-wrapper">
                  <nav className="questions__nav">
                    <ul className="questions__nav__list">
                      <li className="questions__nav__item">
                        <Link
                          to="/encuesta/#calidad-y-excelencia"
                          className="list__link"
                        >
                          1. Calidad y Excelencia
                        </Link>
                      </li>
                      <li className="questions__nav__item">
                        <Link
                          to="/encuesta/#calidad-y-equipamiento"
                          className="list__link"
                        >
                          2. Calidad y Equipamiento
                        </Link>
                      </li>
                      <li className="questions__nav__item">
                        <Link
                          to="/encuesta/#equipamiento"
                          className="list__link"
                        >
                          3. Equipamiento
                        </Link>
                      </li>
                      <li className="questions__nav__item">
                        <Link
                          to="/encuesta/#instalaciones"
                          className="list__link"
                        >
                          4. Instalaciones
                        </Link>
                      </li>
                      <li className="questions__nav__item">
                        <Link
                          to="/encuesta/#capacidad-de-analisis"
                          className="list__link"
                        >
                          5. Capacidad de análisis
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </section>
              <section className="section">
                <div className="section__wrapper container">
                  <h2 className="title">Nuestra forma de trabajo</h2>
                  <ul className="cards row">
                    <li className="card col">
                      <h3 className="title">Extracción</h3>
                      <p className="text">
                        Generamos códigos de barras individuales para el
                        rotulado de muestras, asegurando que resultados
                        obtenidos refieren al paciente inequívocamente.
                      </p>
                    </li>
                    <li className="card col">
                      <h3 className="title">Resultados</h3>
                      <p className="text">
                        Además de entregar los resultados en papel, podemos
                        enviarlos sin costos vía email o WhatsApp, de forma más
                        eficiente y ecológica.
                      </p>
                    </li>
                    <li className="card card--highlighted col">
                      <h3 className="title">
                        <strong>¡Próximamente!</strong>
                      </h3>
                      <p className="text">
                        Se le brindará un usuario y contraseña, y a través de
                        nuestro sitio web podrá ingresar a los resultados de sus
                        pacientes, como así también poder explorar el histórico
                        de cada uno de ellos.
                      </p>
                    </li>
                  </ul>
                </div>
              </section>
              <section className="form">
                <div className="form__wrapper container">
                  <h2 className="title">¡Completá tus datos y participá!</h2>
                  <fieldset className="form__fieldset">
                    <Field
                      type="text"
                      name="nombre"
                      placeholder="Nombre"
                      className="form__input"
                    />
                    <Field
                      type="number"
                      name="dni"
                      placeholder="DNI"
                      className="form__input"
                    />
                    <Field
                      type="number"
                      name="matricula"
                      placeholder="Matricula"
                      className="form__input"
                    />
                    <Field
                      type="email"
                      name="email"
                      placeholder="E-mail"
                      className="form__input"
                    />
                    <Field
                      type="phone"
                      name="telefono"
                      placeholder="Teléfono"
                      className="form__input"
                    />
                    <Field
                      component="textarea"
                      name="comentario"
                      placeholder="¿Tenés alguna duda o comentario?"
                      className="form__input form__input--textarea"
                    />
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`form__submit ${status ? status.css : ""}`}
                    >
                      {status ? status.success : "Enviar"}
                    </button>
                  </fieldset>
                </div>
              </section>
            </Form>
          )}
        />
        <section id="contact" className="contact-footer">
          <div className="contact-footer__wrapper container">
            <div className="row">
              <div className="contact-footer__info col">
                <h2 className="subtitle">Contacto</h2>
                <h3 className="title">
                  Conocé nuestros
                  <br /> medios de contacto.
                </h3>
              </div>
              <div className="col">
                <div className="contact-footer__items">
                  <div className="contact-footer__items__item">
                    <h4 className="title">Horarios de extracción</h4>
                    <p className="text">
                      Lunea a Viernes de 7:00 a 12:30
                      <br />
                      Sábados de 7:00 a 12:00
                    </p>
                  </div>
                  <div className="contact-footer__items__item">
                    <h4 className="title">Dirección</h4>
                    <p className="text">
                      Pueyrredón 367, Las Flores,
                      <br />
                      Buenos Aires, Argentina.
                    </p>
                  </div>
                  <div className="contact-footer__items__item">
                    <h4 className="title">Teléfonos</h4>
                    <p className="text">
                      Tel./Fax:{" "}
                      <a href="tel:02244-453064" className="text__link">
                        02244-453064
                      </a>
                    </p>
                    <p className="text">
                      WhatsApp:{" "}
                      <a href="tel:02244-507685" className="text__link">
                        02244-507685
                      </a>
                    </p>
                  </div>
                  <div className="contact-footer__items__item">
                    <h4 className="title">Redes sociales</h4>
                    <p className="text">
                      Instagram:{" "}
                      <a
                        href="https://www.instagram.com/laboratorio_dorronsoro/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text__link"
                      >
                        @laboratorio_dorronsoro
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <img src={cellBackground} alt="" className="main__background-image" />
      </main>
    );
  }
}

export default Quiz;
